/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import Spacing from '../Spacing';
import { pageTitle } from '../../helpers/PageTitle';
import { dentalServiceDetailById } from '../../service/api';
import { previewAssetUrl } from '../../helpers';

export default function ServiceDetail() {
  const { serviceId: id } = useParams();
  const [service, setService] = useState(null);

  const fetchService = async () => {
    try {
      const res = await dentalServiceDetailById(id);
      setService(res.data);
    } catch (error) {
      setService(null);
    }
  };

  useEffect(() => {
    fetchService();
  }, [id]);

  pageTitle(service?.title || 'Chi tiết dịch vụ');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={service?.title || ''} />
        {service?.description && (
          <div className='container'>
            <p
              style={{
                fontSize: '20px',
                lineHeight: '1.6',
                color: '#555',
                marginTop: '16px',
              }}
            >
              {service.description}
            </p>
          </div>
        )}
      </Section>
      <div className='container'>
        <Spacing md='40' lg='30' />
        <div className='row'>
          <div className='col-lg-12'>
            <div
              className='cs_blog_details'
              dangerouslySetInnerHTML={{
                __html: service?.content,
              }}
            />
          </div>
        </div>
      </div>
      <Spacing md='200' xl='150' lg='110' />
    </>
  );
}
